// @flow
import * as React from 'react';

import { StyledHeadlineTextSectionBright, StyledSubHeadlineSectionBright } from '@components/Headlines';
import { withTranslation } from '@i18n';

import type { Props } from './types';

import {
  StyledCover,
  StyledGradient,
  StyledContentCover,
  StyledText,
  StyledButton
} from './styles';

const Contact = ({ t }: Props): React.Node => (
  <StyledCover>
    <StyledGradient />

    <StyledContentCover>
      <StyledHeadlineTextSectionBright>{t('Contact.Title')}</StyledHeadlineTextSectionBright>
      <StyledSubHeadlineSectionBright>{t('Contact.Subtitle')}</StyledSubHeadlineSectionBright>

      <StyledText>{t('Contact.Copy')}</StyledText>

      <StyledButton href="tel:+918056005099">{t('Contact.ButtonLabel')}</StyledButton>
    </StyledContentCover>
  </StyledCover>
);

export default withTranslation('Hospitals')(Contact);
